import useMediaQuery from './useMediaQuery';

const useIsMobile = () => {
  return useMediaQuery('md');
};

export default useIsMobile;